import type { NessoContent } from '../model/session-note.types';

export const BLANK_NESSO_NOTE_CONTENT: NessoContent = {
    chiefComplaint: {
        emotion: [],
        about: '',
        directQuote: '',
        relatedTo: [],
    },
    clientPresentation: {
        mildLow: [],
        moderate: [],
        highSevere: [],
    },
    risk: {
        areaOfRisk: [],
        disposition: [],
        protectiveFactors: [],
        riskFactors: [],
        descriptionOfRisk: '',
        safetyPlan: '',
    },
    interventions: [],
    progress: {
        improvement: [],
        managingSymptoms: [],
        continuesToStruggle: [],
        impactsToDailyLife: [],
        barriersToProgress: '',
    },
    plan: {
        homework: [],
        resourcesAndRecommendations: '',
        followUpOn: '',
    },
    additionalNotes: '',
};
